import { Identifiable } from './identifiable';
import { BaseEntity } from './base-entity';

export class CustomValue<T> implements Identifiable {
  id: string;
  field: BaseEntity;
  value: T;
  type: string;
}
